//input from coach "generation request"
export interface ReportInputRequest {
  userId: string
  startDate: string
  weeksCountMax: number
  experiments: {
    id: string
    eventId1: string
    eventId2: string
    manual_description: string
  }[]
  goals: {
    id: string
    main: boolean
  }[]
  directions: {
    id: string
    level: ReportDirectionLevels
  }[]
}

//to get possible input select options for coach input
export interface ReportInputFields {
  experiments: ReportExperimentChoice[]
  goals: ReportGoalChoice[]
  directions: ReportDirectionChoice[]
  direction_levels: Record<ReportDirectionLevels, ReportDirectionLevels>
}

export type ReportExperimentChoice = {
  id: string
  title: string
  img: string
  science_description: string
}

export type ReportGoalChoice = {
  id: string
  title: string
  science_description_title: string
  img: string
}

export type ReportDirectionChoice = {
  id: string
  title: string
  img: string
}

export enum ReportDirectionLevels {
  EASY = 'EASY',
  TRICKY = 'TRICKY',
  HARD = 'HARD',
}
